// @flow
import React from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import baseStyles from './ResizableTextarea.scss'

type Props = {
  ...StyleProps
}

const ResizableTextarea = ({ styles, ...rest }: Props) => {
  return (
    <div className={styles.root}>
      {/* $FlowFixMe[cannot-spread-inexact] */}
      <TextareaAutosize
        className={styles['form-control']}
        {...rest}
      />
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(ResizableTextarea)
